import { createShallowStore, createStore } from '@frontend/store';

type ServiceTypesHelperStore = {
  isPaymentsEnabled: boolean;
  setPaymentsEnabled: (isPaymentsEnabled: boolean) => void;

  isOnlineSchedulingEnabled: boolean;
  setIsOnlineSchedulingEnabled: (isOnlineSchedulingEnabled: boolean) => void;
};

const useServiceTypesHelperStore = createStore<ServiceTypesHelperStore>(
  (set) => ({
    isPaymentsEnabled: false,
    setPaymentsEnabled: (isPaymentsEnabled) => set({ isPaymentsEnabled }),

    isOnlineSchedulingEnabled: false,
    setIsOnlineSchedulingEnabled: (isOnlineSchedulingEnabled) => set({ isOnlineSchedulingEnabled }),
  }),
  {
    name: 'serviceTypesHelper',
  }
);

export const useServiceTypesHelperShallowStore =
  createShallowStore<ServiceTypesHelperStore>(useServiceTypesHelperStore);
